export const accommodationGallery = {
  ACCOMMODATION_GALLERY: 'accommodationGallery.slider',
  ACCOMMODATION_GALLERY_OPEN: 'accommodationGallery.sliderOpen'
}
